import api, { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'

interface ProductReview {
  productId: string
  shopId: string
  payload: {
    userId?: string
    rate: number
    comment: string
    fullName: string
    email: string
  }
}

export const useProductReviews = (
  shopId: string,
  productId: string,
  filter: any,
) => {
  const endpoint: string = `${API_ENDPOINTS.PRODUCT_REVIEW(shopId, productId)}`
  let queryString = ''
  if (filter) {
    queryString = Object.keys(filter)
      .map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(filter[key])
      })
      .join('&')
  }
  const url: string = filter ? `${endpoint}?${queryString}` : endpoint
  const { data, isError, isLoading, mutate } = useApi(url)
  return {
    reviews: data?.data,
    isLoading,
    isError,
    mutate,
  }
}

export const addProductReview = async (
  shopId: string,
  productId: string,
  userId: string,
  payload: ProductReview['payload'],
) => {
  try {
    const url: string = `${API_ENDPOINTS.ADD_REVIEW(shopId, productId, userId)}`
    const { data } = await api.post(url, payload)
    return { review: { ...data } }
  } catch (error: any) {
    const data = {
      data: null,
      msg: error?.response?.data?.msg,
      success: false,
    }
    return { review: { ...data } }
  }
}

export const editProductReview = async (
  shopId: string,
  productId: string,
  reviewId: string,
  userId: string,
  payload: ProductReview['payload'],
) => {
  try {
    const url: string = `${API_ENDPOINTS.EDIT_REVIEW(
      shopId,
      productId,
      reviewId,
      userId,
    )}`
    const { data } = await api.patch(url, payload)
    return { review: { ...data } }
  } catch (error: any) {
    const data = {
      data: null,
      msg: error?.response?.data?.msg,
      success: false,
    }
    return { review: { ...data } }
  }
}
